import {ReactNode, useCallback, useEffect, useMemo, useState} from 'react'
import {MetronicIconButton} from '../MetronicIconButton'
import {TreeNodeCheckbox} from './TreeNodeCheckbox'
import {TreeSelectNode} from './TreeSelectNode'
import {TreeSelectNodeCollection} from './TreeSelectNodeCollection'
export interface TreeNodeNodeProps {
  node: TreeSelectNode
  tree: TreeSelectNodeCollection
  onChange: (value: TreeSelectNodeCollection, node: TreeSelectNode, isChecked: boolean) => void
  radioName?: string
  level: number
  onBlur?: () => void
}

export const TreeNode = ({onChange, node, radioName, level, tree, onBlur}: TreeNodeNodeProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  const handleCheckboxChange = useCallback(
    (isChecked: boolean) => {
      tree.setNodeValue(node.id, isChecked)
      onChange(tree, node, isChecked)
    },
    [onChange, tree, node]
  )

  const itemElements = useMemo(() => {
    const nodes: ReactNode[] = []
    if (node.children.length && isCollapsed) {
      node.children.forEach((node) => {
        nodes.push(
          <TreeNode
            onBlur={onBlur}
            key={node.id}
            level={level + 1}
            node={node}
            onChange={onChange}
            tree={tree}
            radioName={radioName}
          />
        )
      })
    }
    return nodes
  }, [node.children, isCollapsed, onBlur, level, onChange, tree, radioName])

  const toggleCollapse = useCallback(() => {
    setIsCollapsed(!isCollapsed)
  }, [isCollapsed])

  const collapseButton = useMemo(() => {
    if (!node.children.length) {
      return (
        <button
          type='button'
          className='btn btn-sm btn-icon bt-active-light-primary flex-shrink-0'
          style={{display: 'inline-block', cursor: 'default'}}
        >
          &nbsp;
        </button>
      )
    }
    return (
      <MetronicIconButton
        className='flex-shrink-0'
        onClick={toggleCollapse}
        size='sm'
        type='button'
        iconType='Navigation'
        iconName={isCollapsed ? 'Angle-down' : 'Angle-right'}
      />
    )
  }, [node, toggleCollapse, isCollapsed])

  useEffect(() => {
    if (radioName && node.hasChildrenSelected()) {
      setIsCollapsed(true)
    }
  }, [node, radioName])

  return (
    <div
      style={{
        marginLeft: `${Math.min(level, 1)}rem`,
        display: 'flex',
      }}
    >
      {collapseButton}
      <div
        className='my-2'
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TreeNodeCheckbox
          onBlur={onBlur}
          node={node}
          onChange={handleCheckboxChange}
          radioName={radioName}
        />
        {itemElements}
      </div>
    </div>
  )
}
